import React from "react";
import { Grid, MenuItem } from "@mui/material";
import { MuiTelInput, MuiTelInputInfo } from "mui-tel-input";
import {
  FieldLabel,
  StyledSelect,
  StyledTextField,
} from "../types/company-form";

export interface RepFormValues {
  firstName: string;
  lastName: string;
  role: string;
  phone: string;
  email: string;
}

const ROLES = [
  "Director",
  "Manager",
  "Sales Representative",
  "Account Executive",
  "Operations Lead",
  "Marketing Manager",
  "HR Manager",
  "Finance Officer",
  "Other",
];

export default function RepFormFields({
  values,
  onChange,
  onPhoneChange,
  onRoleChange,
  color100,
  color300,
  color700,
  color800,
}: {
  values: RepFormValues;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPhoneChange: (value: string, info: MuiTelInputInfo) => void;
  onRoleChange: (role: string) => void;
  color100?: string;
  color300?: string;
  color700?: string;
  color800?: string;
}) {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <FieldLabel textcolor={color100}>
          First Name <span className="required">*</span>
        </FieldLabel>
        <StyledTextField
          name="firstName"
          placeholder="e.g. Takudzwa"
          value={values.firstName}
          onChange={onChange}
          inputbg={color800}
          textcolor={color700}
          placeholdercolor={color300}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FieldLabel textcolor={color100}>Last Name</FieldLabel>
        <StyledTextField
          name="lastName"
          placeholder="e.g. Moyo"
          value={values.lastName}
          onChange={onChange}
          inputbg={color800}
          textcolor={color700}
          placeholdercolor={color300}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <FieldLabel textcolor={color100}>Role / Title</FieldLabel>
        <StyledSelect
          value={values.role}
          displayEmpty
          selectbg={color800}
          textcolor={color700}
          sx={{ maxWidth: 260 }}
          onChange={(e) => onRoleChange(String(e.target.value))}
          renderValue={(selected) =>
            selected ? (
              <span style={{ color: color700 }}>{selected as string}</span>
            ) : (
              <span style={{ color: color300 }}>Select role...</span>
            )
          }
        >
          {ROLES.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </StyledSelect>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FieldLabel textcolor={color100}>Phone</FieldLabel>
        <MuiTelInput
          fullWidth
          value={values.phone}
          defaultCountry="ZW"
          onChange={onPhoneChange}
          placeholder="e.g. +263 77 123 4567"
          MenuProps={{
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
            disablePortal: true,
            PaperProps: { sx: { maxHeight: 250, mt: 1 } },
          }}
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              backgroundColor: color800,
              borderRadius: "30px",
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              fontSize: "13px",
              color: color700,
            },
            "& .MuiInputBase-input": {
              padding: "10px 14px",
              fontSize: "13px",
              color: color700,
            },
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FieldLabel textcolor={color100}>Email</FieldLabel>
        <StyledTextField
          name="email"
          placeholder="rep@company.com"
          type="email"
          value={values.email}
          onChange={onChange}
          inputbg={color800}
          textcolor={color700}
          placeholdercolor={color300}
        />
      </Grid>
    </Grid>
  );
}
